import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { service_controllers_methods } from './service_controllers_methods';
import { ActionType, ActionTypeBillingDetail, ActiveInactiveFor, ActiveSession, ActiveSessions, AddBillWrapper, BilledProduct, BillingDetailSimple, BillingDetailsSimple, BillingInitialization, BillingStatus, BillingValidation, CommunicationTemplate, CustomPrintLabelForBill, CustomPrintLabelForBills, GeneralConfigType, InteractionType, KeyValueId, KeyValueIdForPaymentMode, KeyValueIdForPaymentModeWrapper, KeyValueIdGroup, KeyValueInt, KeyValues10, KeyValues10Date, KeyValues15, KeyValues3, KeyValues5, KeyValueSet, KeyValueSetInt, KeyValueSets, KeyValueSetsInt, LiveTokenWrapper, LocalService, MessageSettingsWrapper, NotificationType, Paging, Payment, PrepaidDetailReason, ReceiptHtml, ReceiptOption, ReceiptTemplate, ReceiptTemplateWrapper, ReceiptType, ReturnInitialization, SeatsInitialization, SerialNumberMapInitialization, Status, StatusWithId, Wrapper10Initialization, Wrapper15Initialization, Wrapper20Initialization, Wrapper5Initialization, Wrappers10, Wrappers15, Wrappers20, Wrappers5 } from './local.service';
import { HttpRequestComponent } from '../app/shared/http-request/http-request.component';
import { ReceiptPrintData } from 'src/app/supporting/receiptPrint';
import { TemplateOptions } from 'src/app/entities/request';
import { ExcelData } from './file-save.service';

@Injectable({
  providedIn: 'root'
})
export class BillingManagementService {
  private controllerName = service_controllers_methods.billing.controller;
  private methods = service_controllers_methods.billing.methods;

  constructor(private localService: LocalService, private httpService: HttpRequestComponent) { }

  public addBillingDetail(billWrapper: AddBillWrapper): Observable<BillingDetailSimple> {
    const body = {
      sel: this.localService.getSelected(),
      billWrapper: billWrapper
    };
    return this.httpService.request_general_post(this.controllerName + this.methods.AddBillingDetail, body);
  }

  public getBills(strBusinessId: string, strToken: string, selectedStatus: string, paging: Paging, isExcluded: boolean, customerId: string): Observable<Wrappers10> {
    if (paging == null)
      paging = this.localService.getLastPagingSetup(GeneralConfigType.PagingBills);

    var body = {
      sel: this.localService.getSelected(),
      dt: { isSelected: isExcluded, v1: strBusinessId, v2: strToken, v3: selectedStatus, v4: customerId } as KeyValues5,
      pag: paging
    };
    return this.httpService.request_general_post(this.controllerName + this.methods.GetBills, body);
  }

  public getBilledProducts(strBillingId: string, strPrintingLanguage = '', isSerialNumberRequired = false, isQrRequired = false, isRequ = false, isShowSpinner = true, isGetCustomLabels = false, isFixedCustomLabels = false): Observable<BillingDetailsSimple> {
    let body = {
      sel: this.localService.getSelected(),
      dt: { v1: strBillingId, v2: strPrintingLanguage, v3: isSerialNumberRequired ? '1' : '0', v6: isQrRequired ? '1' : '0', v7: isRequ ? '1' : '0', v8: isGetCustomLabels ? '1' : '0', v9: isFixedCustomLabels ? '1' : '0' } as KeyValues10
    };
    return this.httpService.request_general_post(this.controllerName + this.methods.GetBilledProducts, body, isShowSpinner);
  }

  public getInitialization(strBusinessId: string): Observable<BillingInitialization> {
    let body = {
      sel: this.localService.getSelected(),
      v1: strBusinessId
    };
    return this.httpService.request_general_post(this.controllerName + this.methods.GetInitialization, body);
  }

  public removeBillingDetail(strBillingId: string, strProductId: string, batchId: string, measurementType?: number): Observable<StatusWithId> {
    let body = {
      sel: this.localService.getSelected(),
      dt: { v1: strBillingId, v2: strProductId, v3: batchId, v4: measurementType ? measurementType.toString() : undefined } as KeyValues5
    };
    return this.httpService.request_general_post(this.controllerName + this.methods.RemoveBillingDetail, body);
  }

  public updateBillingStatus(strId: string, status: BillingStatus, tableId?: string): Observable<BillingDetailsSimple> {
    let body = {
      sel: this.localService.getSelected(),
      dt: { v1: strId, v2: tableId } as KeyValues5,
      iStatusToUpdate: status
    };
    return this.httpService.request_general_post(this.controllerName + this.methods.UpdateBillingStatus, body);
  }

  public saveReceiptTemplate(wrapper: KeyValues5): Observable<StatusWithId> {
    let body = {
      sel: this.localService.getSelected(),
      wrapper: wrapper,
    };
    return this.httpService.request_general_post(this.controllerName + this.methods.SaveReceiptTemplate, body);
  }

  public getReceiptTemplateOld(strParentId: any, isEditMode: boolean = false, isGeneral: boolean = false, strPrintingLangauge = '', isForBusiness = false): Observable<ReceiptTemplateWrapper> {
    let temp = this.localService.getSelected();
    if (isEditMode)
      temp.v2 = '';
    let body = {
      sel: temp,
      dt: { isSelected: isGeneral, v1: strParentId, v2: strPrintingLangauge, v3: isForBusiness ? '1' : '0', v4: isEditMode ? '1' : '0' } as KeyValues5
    };
    return this.httpService.request_general_post(this.controllerName + this.methods.GetReceiptTemplate, body);
  }

  public getReceiptTemplate(receiptType: ReceiptType, businessId: string = '', isInCludeInActive = false): Observable<ReceiptTemplate | ReceiptHtml | undefined> {
    let body = {
      sel: this.localService.getSelected(),
      dt: { isSelected: isInCludeInActive, v1: businessId, v2: receiptType.toString() } as KeyValues3
    };
    return this.httpService.request_general_post(this.controllerName + this.methods.GetReceiptTemplate, body);
  }

  public updateBusinessType(strBillingId: string, strBillingType: string, bizId: string): Observable<BilledProduct[]> {
    let body = {
      sel: this.localService.getSelected(),
      dt: {
        v1: strBillingId,
        v2: strBillingType,
        v3: this.localService.isBusinessHasPurchaseEntry(bizId) ? '1' : '0'
      } as KeyValues3
    };
    return this.httpService.request_general_post(this.controllerName + this.methods.UpdateBusinessType, body);
  }

  public getDeletedItems(strBillingId: string): Observable<KeyValues10[]> {
    let body = {
      sel: this.localService.getSelected(),
      v1: strBillingId
    };
    return this.httpService.request_general_post(this.controllerName + this.methods.GetDeletedItems, body);
  }

  public updateBusinessBRN(strUserId: string, strBillingId: string, strBusinessId: string, isCutomer: boolean, isForBusiness: boolean): Observable<StatusWithId> {
    let body = {
      sel: this.localService.getSelected(),
      dt: { key: strBillingId, v1: strUserId, v2: isCutomer ? '1' : '0', v3: isForBusiness ? '1' : '0', v4: strBusinessId } as KeyValues5
    };
    return this.httpService.request_general_post(this.controllerName + this.methods.UpdateBusinessBRN, body);
  }

  public updateQty(bizId: string, strBillingId: string, strProductId: string, qty: any, billingValidations: BillingValidation[], batchId: string, measurementType?: number, bizTaxes?: KeyValueIdGroup[]): Observable<StatusWithId> {
    let body = {
      sel: this.localService.getSelected(),
      dt: { key: '', v1: strBillingId, v2: strProductId, v3: qty, v4: batchId, v5: measurementType ? measurementType.toString() : undefined } as KeyValues5,
      validation: billingValidations,
      dt3: bizTaxes,
    };
    return this.httpService.request_general_post(this.controllerName + this.methods.UpdateQty, body);
  }

  public onAction(strBillingId: string, actionType: ActionType, value: any, isShowSpinner: boolean = true): Observable<BillingDetailsSimple> {
    let body = {
      sel: this.localService.getSelected(),
      dt: { key: strBillingId, v1: actionType.toString(), v2: value.toString() } as KeyValues3
    };
    return this.httpService.request_general_post(this.controllerName + this.methods.OnAction, body, isShowSpinner);
  }

  public saveAppointment(data: KeyValues10Date): Observable<StatusWithId> {
    let body = {
      sel: this.localService.getSelected(),
      dt: data
    };
    return this.httpService.request_general_post(this.controllerName + this.methods.SaveAppointment, body);
  }

  public getAppointment(strId): Observable<KeyValues10Date> {
    let body = {
      sel: this.localService.getSelected(),
      dt: strId
    };
    return this.httpService.request_general_post(this.controllerName + this.methods.GetAppointment, body);
  }

  public returnProducts(data: KeyValueSets): Observable<StatusWithId> {
    let body = {
      sel: this.localService.getSelected(),
      dt: data
    };
    return this.httpService.request_general_post(this.controllerName + this.methods.ReturnProducts, body);
  }

  public getReturnInitialization(strBillingId: string): Observable<ReturnInitialization> {
    let body = {
      sel: this.localService.getSelected(),
      dt: strBillingId
    };
    return this.httpService.request_general_post(this.controllerName + this.methods.GetReturnInitialization, body);
  }

  public saveSerialNumbers(strBillingId: string, strProductId: string, lstSerialNumbers: string[], batchId: string): Observable<StatusWithId> {
    let body = {
      sel: this.localService.getSelected(),
      dt: { v1: strBillingId, v2: strProductId, v3: batchId } as KeyValues3,
      coll: lstSerialNumbers
    };
    return this.httpService.request_general_post(this.controllerName + this.methods.SaveSerialNumbers, body);
  }

  public getSerialNumberMapInitialization(strBillingId: string, strProductId: string, batchId: string): Observable<SerialNumberMapInitialization> {
    let body = {
      sel: this.localService.getSelected(),
      dt: { v1: strBillingId, v2: strProductId, v3: batchId } as KeyValues3
    };
    return this.httpService.request_general_post(this.controllerName + this.methods.GetSerialNumberMapInitialization, body);
  }

  public copyBill(strBillingId: string, bizId: string): Observable<StatusWithId> {
    let body = {
      sel: this.localService.getSelected(),
      dt: {
        key: strBillingId,
        v1: this.localService.isBusinessHasPurchaseEntry(bizId) ? '1' : '0'
      } as KeyValues3
    };
    return this.httpService.request_general_post(this.controllerName + this.methods.CopyBill, body);
  }

  public getBillingIdByToken(strBusinessId: string, strToken: string): Observable<KeyValueSet> {
    let body = {
      sel: this.localService.getSelected(),
      dt: { key: strToken, v1: strBusinessId } as KeyValues3
    };
    return this.httpService.request_general_post(this.controllerName + this.methods.GetBillingIdByToken, body);
  }

  public getBusinessIdByBillingId(dtrBillingId: string): Observable<StatusWithId> {
    let body = {
      sel: this.localService.getSelected(),
      dt: { v1: dtrBillingId } as KeyValues3
    };
    return this.httpService.request_general_post(this.controllerName + this.methods.GetBusinessIdByBillingId, body);
  }

  public getSalesReport(strBusinessId: string, paging: Paging, reportBy: number, paymentBy: number, isDetailedReport: boolean, searchKey: string, isExcluded: boolean, customerId: string, productLabel: string): Observable<Wrappers20> {
    let body = {
      sel: this.localService.getSelected(),
      dt: { isSelected: isDetailedReport, v1: strBusinessId, v2: reportBy.toString(), v3: searchKey, v4: paymentBy.toString(), v5: isExcluded ? '1' : '0', v6: customerId, v8: productLabel } as KeyValues10,
      pag: paging
    };
    return this.httpService.request_general_post(this.controllerName + this.methods.GetSalesReport, body, paging && !paging.isAutoRefresh);
  }

  public getSalesReportInitialization(strBusinessId: string): Observable<Wrapper20Initialization> {
    let body = {
      sel: this.localService.getSelected(),
      dt: { v1: strBusinessId } as KeyValues3,
      pag: null
    };
    return this.httpService.request_general_post(this.controllerName + this.methods.GetSalesReportInitialization, body);
  }

  public getExcelData(strBusinessId: string, paging: Paging, reportBy: number, paymentBy: number, isDetailedReport: boolean, searchKey: string, isExcluded: boolean, customerId: string, productLabel: string, isOnlyHours: boolean = false): Observable<ExcelData[]> {
    let body = {
      sel: this.localService.getSelected(),
      dt: { isSelected: isDetailedReport, v1: strBusinessId, v2: reportBy.toString(), v3: searchKey, v4: isOnlyHours ? '1' : '0', v5: paymentBy.toString(), v6: isExcluded ? '1' : '0', v7: customerId, v8: productLabel } as KeyValues10,
      pag: paging
    };
    return this.httpService.request_general_post_blob_response(this.controllerName + this.methods.GetExcelData, body);
  }

  public getMessageSettings(strBusinessId: string, notificationType: NotificationType, relationShipType: InteractionType, isLoadOptions: boolean): Observable<MessageSettingsWrapper> {
    let body = {
      sel: this.localService.getSelected(),
      dt: { v1: strBusinessId, v2: notificationType.toString(), v3: relationShipType.toString(), v4: isLoadOptions ? '1' : '0' } as KeyValues5
    };
    return this.httpService.request_general_post(this.controllerName + this.methods.GetMessageSettings, body);
  }

  public saveMessageSettings(wrapper: MessageSettingsWrapper, lstCopyToNotification: number[]): Observable<StatusWithId> {
    let body = {
      sel: this.localService.getSelected(),
      dt: wrapper,
      dt2: lstCopyToNotification
    };
    return this.httpService.request_general_post(this.controllerName + this.methods.SaveMessageSettings, body);
  }

  public getMessageCredit(strBusinessId: string, notificationType: NotificationType, relationShipType: InteractionType): Observable<KeyValues5> {
    let body = {
      sel: this.localService.getSelected(),
      dt: { v1: strBusinessId, v2: notificationType.toString(), v3: relationShipType.toString() } as KeyValues5
    };
    return this.httpService.request_general_post(this.controllerName + this.methods.GetMessageCredit, body);
  }

  public saveMessageCredits(wrapper: KeyValues5[], payment: Payment): Observable<StatusWithId[]> {
    let body = {
      sel: this.localService.getSelected(),
      dt: wrapper,
      py: payment
    };
    return this.httpService.request_general_post(this.controllerName + this.methods.SaveMessageCredits, body);
  }

  public getMessageLogs(strBusinessId: string, notificationType: NotificationType, relationShipType: InteractionType, paging: Paging): Observable<Wrappers5> {
    let body = {
      sel: this.localService.getSelected(),
      dt: { v1: strBusinessId, v2: notificationType.toString(), v3: relationShipType.toString() } as KeyValues5,
      pag: paging
    };
    return this.httpService.request_general_post(this.controllerName + this.methods.GetMessageLogs, body);
  }

  public getMessageCredits(strBusinessId: string, relationShipType: InteractionType): Observable<KeyValues5[]> {
    let body = {
      sel: this.localService.getSelected(),
      dt: { v1: strBusinessId, v2: "", v3: relationShipType.toString() } as KeyValues5
    };
    return this.httpService.request_general_post(this.controllerName + this.methods.GetMessageCredits, body);
  }

  public savePrepaidDetail(strBusinessId: string, amount: number, interactionType: InteractionType, payment: Payment): Observable<StatusWithId> {
    let body = {
      sel: this.localService.getSelected(),
      dt: { v1: strBusinessId, v2: interactionType.toString(), v3: amount.toString(), v4: '1' } as KeyValues10,
      py: payment
    };
    return this.httpService.request_general_post(this.controllerName + this.methods.SavePrepaidDetail, body);
  }

  public getPrepaidDetails(strBusinessId: string, interactionType: InteractionType, paging: Paging): Observable<Wrappers5> {
    let body = {
      sel: this.localService.getSelected(),
      dt: { v1: strBusinessId, v2: interactionType.toString() } as KeyValues3,
      pag: paging
    };
    return this.httpService.request_general_post(this.controllerName + this.methods.GetPrepaidDetails, body);
  }

  public getPaymentFromWalletDetails(strReceiptId: string, prepaidDetailReason: PrepaidDetailReason, dblAmount: number = null): Observable<KeyValues15> {
    let body = {
      sel: this.localService.getSelected(),
      dt: { v1: strReceiptId, v2: dblAmount ? dblAmount.toString() : 0, v3: prepaidDetailReason.toString() } as KeyValues3
    };
    return this.httpService.request_general_post(this.controllerName + this.methods.GetPaymentFromWalletDetails, body);
  }

  public updateUpiByReceiptId(strReceiptId: string, strUpi: string): Observable<StatusWithId> {
    let body = {
      sel: this.localService.getSelected(),
      dt: { v1: strReceiptId, v2: strUpi } as KeyValues3
    };
    return this.httpService.request_general_post(this.controllerName + this.methods.UpdateUpiByReceiptId, body);
  }

  public deductFromPrepaid(strBusinessOrUserId: string, interactionType: InteractionType, dblAmount: number, prepaidDetailReason: PrepaidDetailReason, strReceiptId: string, ids: string[] = null): Observable<StatusWithId> {
    let body = {
      sel: this.localService.getSelected(),
      dt: { v1: strBusinessOrUserId, v2: interactionType.toString(), v3: dblAmount.toString(), v4: prepaidDetailReason.toString(), v5: strReceiptId } as KeyValues5,
      ids: ids ? ids : []
    };
    return this.httpService.request_general_post(this.controllerName + this.methods.DeductFromPrepaid, body);
  }

  public paidByCompany(strBusinessOrUserId: string, interactionType: InteractionType, dblAmount: number, prepaidDetailReason: PrepaidDetailReason, strUpiId: string, notes: string, countryCode: string, paymentIdFromGateWay: string = ''): Observable<StatusWithId> {
    let body = {
      sel: this.localService.getSelected(),
      dt: { v1: strBusinessOrUserId, v2: interactionType.toString(), v3: dblAmount.toString(), v4: prepaidDetailReason.toString(), v5: notes, v6: strUpiId, v7: countryCode, v8: paymentIdFromGateWay } as KeyValues10
    };
    return this.httpService.request_general_post(this.controllerName + this.methods.PaidByCompany, body);
  }

  public getPaidByCompanyDetails(strBusinessId: string, interactionType: InteractionType, paging: Paging, prepaidDetailReason: PrepaidDetailReason = PrepaidDetailReason.None, countryCode: string = ''): Observable<Wrappers10> {
    let body = {
      sel: this.localService.getSelected(),
      dt: { v1: strBusinessId, v2: interactionType.toString(), v3: prepaidDetailReason.toString(), v4: countryCode } as KeyValues5,
      pag: paging
    };
    return this.httpService.request_general_post(this.controllerName + this.methods.GetPaidByCompanyDetails, body);
  }

  public getPrepaidDeductPin(strBusinessId: string, interactionType: InteractionType, isForceRefresh: boolean): Observable<KeyValues3> {
    let body = {
      sel: this.localService.getSelected(),
      dt: { v1: strBusinessId, v2: interactionType.toString(), v3: isForceRefresh ? '1' : '0' } as KeyValues3
    };
    return this.httpService.request_general_post(this.controllerName + this.methods.GetPrepaidDeductPin, body);
  }

  public saveSeat(warpper: KeyValues5): Observable<StatusWithId> {
    let body = {
      sel: this.localService.getSelected(),
      dt: warpper
    };
    return this.httpService.request_general_post(this.controllerName + this.methods.SaveSeat, body);
  }

  public getSeatTitles(strBusinessId: string, strParentId: string = ''): Observable<KeyValues3[]> {
    let body = {
      sel: this.localService.getSelected(),
      dt: { v1: strBusinessId, v2: strParentId } as KeyValues3
    };
    return this.httpService.request_general_post(this.controllerName + this.methods.GetSeatTitles, body);
  }

  public activeInactiveStatus(strId: string, actionFor: ActiveInactiveFor): any {
    let body = {
      strId: strId,
      sel: this.localService.getSelected(),
      iActionFor: parseInt(actionFor.toString())
    };
    return this.httpService.request_general_post(this.controllerName + this.methods.ActiveInactiveStatus, body);
  }

  public updateSeatTitle(strId: string, strTitle: string): Observable<Status> {
    let body = {
      sel: this.localService.getSelected(),
      dt: { v1: strId, v2: strTitle } as KeyValues3
    };
    return this.httpService.request_general_post(this.controllerName + this.methods.UpdateSeatTitle, body);
  }

  public getSeatsInitialization(strBusinessId: string): Observable<SeatsInitialization> {
    let body = {
      sel: this.localService.getSelected(),
      dt: { v1: strBusinessId } as KeyValues3
    };
    return this.httpService.request_general_post(this.controllerName + this.methods.GetSeatsInitialization, body);
  }

  public createSession(strBusinessId: string, seats: string[], user: KeyValues3): Observable<StatusWithId> {
    let body = {
      sel: this.localService.getSelected(),
      ids: seats,
      dt: { v1: strBusinessId } as KeyValues3,
      user: user
    };
    return this.httpService.request_general_post(this.controllerName + this.methods.CreateSession, body);
  }

  public clearSession(strSessionId: string, strSeatId: string = ''): Observable<Status> {
    let body = {
      sel: this.localService.getSelected(),
      dt: { v1: strSessionId, v2: strSeatId } as KeyValues3
    };
    return this.httpService.request_general_post(this.controllerName + this.methods.ClearSession, body);
  }

  public getActiveSessions(strBusinessId: string, isLoadSeats: boolean = false): Observable<ActiveSessions> {
    let body = {
      sel: this.localService.getSelected(),
      dt: { v1: strBusinessId, v2: isLoadSeats ? "1" : "0" } as KeyValues3
    };
    return this.httpService.request_general_post(this.controllerName + this.methods.GetActiveSessions, body);
  }

  public getSeatsBySessionId(strSessionId: string, isIncludeInActiveSeat = false): Observable<SeatsInitialization> {
    let body = {
      sel: this.localService.getSelected(),
      dt: { v1: strSessionId, v2: isIncludeInActiveSeat ? "1" : "0" } as KeyValues3
    };
    return this.httpService.request_general_post(this.controllerName + this.methods.GetSeatsBySessionId, body);
  }

  public getSessionBySeat(strSeatId: string): Observable<ActiveSession> {
    let body = {
      sel: this.localService.getSelected(),
      dt: { v1: strSeatId } as KeyValues3
    };
    return this.httpService.request_general_post(this.controllerName + this.methods.GetSessionBySeat, body);
  }

  public clearSeat(strSeatId: string): Observable<Status> {
    let body = {
      sel: this.localService.getSelected(),
      dt: { v1: strSeatId } as KeyValues3
    };
    return this.httpService.request_general_post(this.controllerName + this.methods.ClearSeat, body);
  }

  public attachBill(strBusinessId: string, strTokenNumber: string, sessionOrTableIds: string[], isTable: boolean, billingId?: string): Observable<StatusWithId> {
    let body = {
      sel: this.localService.getSelected(),
      ids: sessionOrTableIds,
      dt: { v1: strBusinessId, v2: strTokenNumber, v3: isTable ? '1' : '0', v4: billingId } as KeyValues5
    };
    return this.httpService.request_general_post(this.controllerName + this.methods.AttachBill, body);
  }

  public getBillsBySessionId(strSessionId: string): Observable<KeyValueSets> {
    let body = {
      sel: this.localService.getSelected(),
      dt: { v1: strSessionId } as KeyValues3
    };
    return this.httpService.request_general_post(this.controllerName + this.methods.GetBillsBySessionId, body);
  }

  public detachBill(billingId: string, sessionOrTableIds: string[], isTable: boolean, businessId: string): Observable<StatusWithId> {
    let body = {
      sel: this.localService.getSelected(),
      ids: sessionOrTableIds,
      dt: { v1: billingId, v2: isTable ? '1' : '0', v3: businessId } as KeyValues3
    };
    return this.httpService.request_general_post(this.controllerName + this.methods.DetachBill, body);
  }

  public getSessionsByBillingId(strBillingId: string): Observable<ActiveSessions> {
    let body = {
      sel: this.localService.getSelected(),
      dt: { v1: strBillingId } as KeyValues3
    };
    return this.httpService.request_general_post(this.controllerName + this.methods.GetSessionsByBillingId, body);
  }

  public createQueue(strBusinessId: string, seatCount: number, user: KeyValues3): Observable<StatusWithId> {
    let body = {
      sel: this.localService.getSelected(),
      dt: { v1: strBusinessId, v2: seatCount.toString() } as KeyValues3,
      user: user
    };
    return this.httpService.request_general_post(this.controllerName + this.methods.CreateQueue, body);
  }

  public getQueues(strBusinessId: string): Observable<KeyValues5[]> {
    let body = {
      sel: this.localService.getSelected(),
      dt: { v1: strBusinessId } as KeyValues3
    };
    return this.httpService.request_general_post(this.controllerName + this.methods.GetQueues, body);
  }

  public clearQueue(strQueueId: string): Observable<Status> {
    let body = {
      sel: this.localService.getSelected(),
      dt: { v1: strQueueId } as KeyValues3
    };
    return this.httpService.request_general_post(this.controllerName + this.methods.ClearQueue, body);
  }

  public getSessions(strBusinessId: string, paging: Paging): Observable<Wrappers10> {
    let body = {
      sel: this.localService.getSelected(),
      dt: { v1: strBusinessId } as KeyValues3,
      pag: paging
    };
    return this.httpService.request_general_post(this.controllerName + this.methods.GetSessions, body);
  }

  public getBillingStatusHistory(strBillingId: string): Observable<KeyValues5[]> {
    let body = {
      sel: this.localService.getSelected(),
      dt: { v1: strBillingId } as KeyValues3
    };
    return this.httpService.request_general_post(this.controllerName + this.methods.GetBillingStatusHistory, body);
  }

  public getBillStatus(strBillingId: string): Observable<KeyValueInt> {
    let body = {
      sel: this.localService.getSelected(),
      dt: { v1: strBillingId } as KeyValues3
    };
    return this.httpService.request_general_post(this.controllerName + this.methods.GetBillStatus, body, false);
  }

  public getLiveTokens(businessId: string, isShowOnlyOwnLoginAssigned: boolean, billingStatues: number[], selectedBilligStatus: string, paging?: Paging): Observable<LiveTokenWrapper> {
    let body = {
      sel: this.localService.getSelected(),
      dt: { v1: businessId, v2: isShowOnlyOwnLoginAssigned ? "1" : "0", v3: selectedBilligStatus } as KeyValues3,
      ids: billingStatues,
      pag: paging
    };
    return this.httpService.request_general_post(this.controllerName + this.methods.GetLiveTokens, body);
  }

  public updateBillingStatusBulk(ids: string[], status: BillingStatus, businessId: string): Observable<StatusWithId[]> {
    let body = {
      sel: this.localService.getSelected(),
      dt: { v1: status.toString(), v2: businessId } as KeyValues3,
      ids: ids
    };
    return this.httpService.request_general_post(this.controllerName + this.methods.UpdateBillingStatusBulk, body);
  }

  public getReportData(strBusinessId: string, paging: Paging, reportBy: number, paymentBy: number, isDetailedReport: boolean, searchKey: string, isExcluded: boolean, customerId: string, productLabel: string): Observable<Wrappers15> {
    let body = {
      sel: this.localService.getSelected(),
      dt: { isSelected: isDetailedReport, v1: strBusinessId, v2: reportBy.toString(), v3: searchKey, v4: paymentBy.toString(), v5: isExcluded ? '1' : '0', v6: customerId, v8: productLabel } as KeyValues10,
      pag: paging
    };
    return this.httpService.request_general_post(this.controllerName + this.methods.GetReportData, body);
  }

  public getReceiptOptionsForBusiness(strBusinessId: string): Observable<ReceiptOption[]> {
    let body = {
      sel: this.localService.getSelected(),
      dt: { v1: strBusinessId } as KeyValues3
    };
    return this.httpService.request_general_post(this.controllerName + this.methods.GetReceiptOptionsForBusiness, body);
  }

  public saveReceiptOptions(strBusinessId: string, receiptOptions: ReceiptOption[]): Observable<StatusWithId> {
    let body = {
      sel: this.localService.getSelected(),
      dt: { v1: strBusinessId } as KeyValues3,
      opts: receiptOptions
    };
    return this.httpService.request_general_post(this.controllerName + this.methods.SaveReceiptOptions, body);
  }

  public getReceiptOptionsHtml(receiptType: ReceiptType, businessId: string = ''): Observable<KeyValueSetsInt[]> {
    let body = {
      sel: this.localService.getSelected(),
      dt: { v1: businessId, v2: receiptType.toString() } as KeyValues3
    };
    return this.httpService.request_general_post(this.controllerName + this.methods.GetReceiptOptionsHtml, body);
  }

  public saveReceiptOptionsHtml(receiptType: ReceiptType, businessId: string = '', htmls: KeyValueSetsInt[]): Observable<StatusWithId> {
    let body = {
      sel: this.localService.getSelected(),
      dt: { v1: businessId, v2: receiptType.toString() } as KeyValues3,
      htmls: htmls
    };
    return this.httpService.request_general_post(this.controllerName + this.methods.SaveReceiptOptionsHtml, body);
  }

  public getQrCodeImage(value: string): Observable<StatusWithId> {
    let body = {
      sel: this.localService.getSelected(),
      dt: { v1: value } as KeyValues3
    };
    return this.httpService.request_general_post(this.controllerName + this.methods.GetQrCodeImage, body);
  }

  public getReceiptHtml(receiptId: string, printingLanguageId: string, printingTemplateId: string): Observable<StatusWithId> {
    let body = {
      sel: this.localService.getSelected(),
      dt: { v1: receiptId, v2: printingLanguageId, v3: printingTemplateId } as KeyValues3
    };
    return this.httpService.request_general_post(this.controllerName + this.methods.GetReceiptHtml, body);
  }

  public removeReceiptPrintCache(businessId: string): Observable<StatusWithId> {
    let body = {
      sel: this.localService.getSelected(),
      dt: { v1: businessId } as KeyValues3
    };
    return this.httpService.request_general_post(this.controllerName + this.methods.RemoveReceiptPrintCache, body, true, false, true);
  }

  public createBillingFromCartSession(sessionId: string, tableId: string): Observable<StatusWithId> {
    let body = {
      sel: this.localService.getSelected(),
      dt: { v1: sessionId, v2: tableId } as KeyValues3
    };
    return this.httpService.request_general_post(this.controllerName + this.methods.CreateBillingFromCartSession, body);
  }

  public onActionBillingDetail(strBillingDetailId: string, actionType: ActionTypeBillingDetail, value: any): Observable<StatusWithId> {
    let body = {
      sel: this.localService.getSelected(),
      dt: { key: strBillingDetailId, v1: actionType.toString(), v2: value.toString() } as KeyValues3
    };
    return this.httpService.request_general_post(this.controllerName + this.methods.OnActionBillingDetail, body);
  }

  public getReceiptPrintLocalByTemplateIds(businessId: string, templateIds: string[], languageCode: string): Observable<ReceiptPrintData[]> {
    let body = {
      sel: this.localService.getSelected(),
      dt: { v1: businessId, v2: languageCode } as KeyValues3,
      ids: templateIds
    };
    return this.httpService.request_general_post(this.controllerName + this.methods.GetReceiptPrintLocalByTemplateIds, body);
  }

  public sendNotificationForBilling(businessId: string, billingId: string, communicationTemplate: CommunicationTemplate): Observable<StatusWithId> {
    let body = {
      sel: this.localService.getSelected(),
      dt: { v1: communicationTemplate.toString(), v2: billingId, v3: businessId } as KeyValues3
    };
    return this.httpService.request_general_post(this.controllerName + this.methods.SendNotificationForBilling, body);
  }

  public getCustomLabelPrintByBillingId(businessId: string, languageId: string, billingId: string, isInitial: boolean): Observable<CustomPrintLabelForBills> {
    let body = {
      dt: { key: this.localService.selected.countryCode, v1: businessId, v2: languageId, v3: billingId, v4: isInitial ? '1' : '0' } as KeyValues5
    };
    return this.httpService.request_general_post(this.controllerName + this.methods.GetCustomLabelPrintByBillingId, body);
  }

  public saveCustomLabelPrintByBillingId(languageId: string, billingId: string, data: CustomPrintLabelForBill[], isSilentSave: boolean = true): Observable<StatusWithId> {
    let body = {
      sel: this.localService.getSelected(),
      dt: { v1: languageId, v2: billingId } as KeyValues3,
      data: data
    };
    return this.httpService.request_general_post(this.controllerName + this.methods.SaveCustomLabelPrintByBillingId, body, !isSilentSave);
  }

  public deleteBills(strBusinessId: string, strToken: string, selectedStatus: string, paging: Paging, isExcluded: boolean, customerId: string): Observable<StatusWithId> {
    var body = {
      sel: this.localService.getSelected(),
      dt: { isSelected: isExcluded, v1: strBusinessId, v2: strToken, v3: selectedStatus, v4: customerId } as KeyValues5,
      pag: paging
    };
    return this.httpService.request_general_post(this.controllerName + this.methods.DeleteBills, body);
  }

  public updatePrice(bizId: string, billingDetailId: string, qty: any, bizTaxes: KeyValueIdGroup[] = [], isNotConsiderTax?: boolean, isShowTaxIncludedPricingInBillingPage?: boolean, billingValidations: BillingValidation[] = []): Observable<StatusWithId> {
    let body = {
      sel: this.localService.getSelected(),
      dt: { key: '', v1: billingDetailId, v3: qty, v4: isNotConsiderTax == true ? '1' : '0', v5: isShowTaxIncludedPricingInBillingPage == true ? '1' : '0' } as KeyValues5,
      validation: billingValidations,
      dt3: bizTaxes,
    };
    return this.httpService.request_general_post(this.controllerName + this.methods.UpdatePrice, body);
  }

  public markProductStatus(billingDetailsId: string[], status: BillingStatus, businessId: string): Observable<StatusWithId> {
    let body = {
      sel: this.localService.getSelected(),
      dt: { v1: status.toString(), v2: businessId } as KeyValues3,
      billingDetailsId: billingDetailsId
    };
    return this.httpService.request_general_post(this.controllerName + this.methods.MarkProductStatus, body);
  }

  public savePaymentModeAmount(businessId: string, billingId: string, paymentDetails: KeyValueIdForPaymentMode[], isPay: boolean, isRemainingAmount: boolean): Observable<StatusWithId> {
    let body = {
      sel: this.localService.getSelected(),
      dt: { v1: billingId, v2: isPay ? '1' : '0', v3: businessId, v4: isRemainingAmount ? '1' : '0' } as KeyValues5,
      dtls: paymentDetails
    };
    return this.httpService.request_general_post(this.controllerName + this.methods.SavePaymentModeAmount, body);
  }

  public getPaymentModeAmount(billingId: string): Observable<KeyValueIdForPaymentModeWrapper> {
    let body = {
      sel: this.localService.getSelected(),
      dt: { v1: billingId } as KeyValues3
    };
    return this.httpService.request_general_post(this.controllerName + this.methods.GetPaymentModeAmount, body);
  }

  public getLatestBillingId(businessId: string): Observable<StatusWithId> {
    let body = {
      sel: this.localService.getSelected(),
      dt: { v1: businessId } as KeyValues3
    };
    return this.httpService.request_general_post(this.controllerName + this.methods.GetLatestBillingId, body);
  }

  public getReceiptHtmls(parentId: string): Observable<KeyValues5[]> {
    let body = {
      sel: this.localService.getSelected(),
      dt: { v1: parentId } as KeyValues3
    };
    return this.httpService.request_general_post(this.controllerName + this.methods.GetReceiptHtmls, body);
  }

  public saveSavedCustomLabel(businessId: string, languageId: string, title: string, customLabelDetails: KeyValueSet[]): Observable<StatusWithId> {
    let body = {
      sel: this.localService.getSelected(),
      dt: { v1: businessId, v2: languageId, v3: title } as KeyValues5,
      data: customLabelDetails
    };
    return this.httpService.request_general_post(this.controllerName + this.methods.SaveSavedCustomLabel, body);
  }

  public getSavedCustomLabels(businessId: string, languageId: string, isShowSpinner = false): Observable<KeyValues5[]> {
    let body = {
      sel: this.localService.getSelected(),
      dt: { v1: businessId, v2: languageId } as KeyValues5
    };
    return this.httpService.request_general_post(this.controllerName + this.methods.GetSavedCustomLabels, body, isShowSpinner);
  }

  public getSavedCustomLabelDetails(id: string): Observable<KeyValueSet[]> {
    let body = {
      sel: this.localService.getSelected(),
      dt: { v1: id } as KeyValues5
    };
    return this.httpService.request_general_post(this.controllerName + this.methods.GetSavedCustomLabelDetails, body);
  }

  public reformatInvoiceNumber(businessId: string): Observable<StatusWithId> {
    let body = {
      sel: this.localService.getSelected(),
      dt: { v1: businessId } as KeyValues5
    };
    return this.httpService.request_general_post(this.controllerName + this.methods.ReformatInvoiceNumber, body);
  }

  public getTokenByBillingId(billingId: string): Observable<StatusWithId> {
    let body = {
      sel: this.localService.getSelected(),
      dt: { v1: billingId } as KeyValues5
    };
    return this.httpService.request_general_post(this.controllerName + this.methods.GetTokenByBillingId, body);
  }

  public saveImage(base64Image: string, businessId: string, billingId: string, customLabelId: string, currentImageUrl: string): Observable<StatusWithId> {
    let body = {
      sel: this.localService.getSelected(),
      base64Image: base64Image,
      dt: { v1: businessId, v2: billingId, v3: customLabelId, v4: currentImageUrl } as KeyValues5
    };
    return this.httpService.request_general_post(this.controllerName + this.methods.SaveImage, body, true, true, true);
  }

  public saveDiscountForBilledProduct(billingDetailId: string, discountValue: any): Observable<StatusWithId> {
    let body = {
      sel: this.localService.getSelected(),
      dt: { v1: billingDetailId, v2: discountValue } as KeyValues3
    };
    return this.httpService.request_general_post(this.controllerName + this.methods.SaveDiscountForBilledProduct, body);
  }

  public getNewDummyBillingId(businessId: string): Observable<StatusWithId> {
    let body = {
      sel: this.localService.getSelected(),
      dt: { v1: businessId } as KeyValues3
    };
    return this.httpService.request_general_post(this.controllerName + this.methods.GetNewDummyBillingId, body);
  }

  public createNoConfigBilling(data: KeyValues5): Observable<StatusWithId> {
    let body = {
      sel: this.localService.getSelected(),
      dt: data
    };
    return this.httpService.request_general_post(this.controllerName + this.methods.CreateNoConfigBilling, body);
  }

  public getNoConfigBillingSuggestion(data: KeyValues3): Observable<KeyValues3[]> {
    let body = {
      sel: this.localService.getSelected(),
      dt: data
    };
    return this.httpService.request_general_post(this.controllerName + this.methods.GetNoConfigBillingSuggestion, body, false);
  }

  public getNoConfigBilling(billingId: string): Observable<Wrappers10> {
    let body = {
      sel: this.localService.getSelected(),
      dt: { v1: billingId } as KeyValues3
    };
    return this.httpService.request_general_post(this.controllerName + this.methods.GetNoConfigBilling, body, false);
  }

  public deleteNoConfigBillingItem(billingId: string, itemId: string): Observable<StatusWithId> {
    let body = {
      sel: this.localService.getSelected(),
      dt: { v1: billingId, v2: itemId } as KeyValues3
    };
    return this.httpService.request_general_post(this.controllerName + this.methods.DeleteNoConfigBillingItem, body, false);
  }

  public getNoConfigBillings(businessId: string, paging?: Paging): Observable<Wrappers10> {
    var body = {
      sel: this.localService.getSelected(),
      dt: { v1: businessId } as KeyValues3,
      pag: paging
    };
    return this.httpService.request_general_post(this.controllerName + this.methods.GetNoConfigBillings, body);
  }

  public getNoConfigBillingSettings(businessId: string): Observable<KeyValues10> {
    var body = {
      sel: this.localService.getSelected(),
      dt: { v1: businessId } as KeyValues3
    };
    return this.httpService.request_general_post(this.controllerName + this.methods.GetNoConfigBillingSettings, body);
  }

  public saveNoConfigBillingSettings(data: KeyValues10): Observable<StatusWithId> {
    var body = {
      sel: this.localService.getSelected(),
      dt: data
    };
    return this.httpService.request_general_post(this.controllerName + this.methods.SaveNoConfigBillingSettings, body);
  }
}
